import e, { useEffect as t } from "react";
import o from "prop-types";
var n = !1,
    s = !1;

var r = function r(_ref) {
  var o = _ref.pageId,
      _ref$language = _ref.language,
      r = _ref$language === void 0 ? "en_US" : _ref$language,
      g = _ref.themeColor,
      a = _ref.height,
      _ref$autoExpand = _ref.autoExpand,
      c = _ref$autoExpand === void 0 ? !0 : _ref$autoExpand,
      l = _ref.loggedInGreeting,
      u = _ref.loggedOutGreeting,
      h = _ref.ref,
      d = _ref.onMessengerMounted,
      m = _ref.onMessengerLoad,
      b = _ref.onMessengerShow,
      p = _ref.onMessengerHide,
      w = _ref.onMessengerDialogShow,
      f = _ref.onMessengerDialogHide,
      _ref$debugMode = _ref.debugMode,
      y = _ref$debugMode === void 0 ? !1 : _ref$debugMode,
      _ref$version = _ref.version,
      C = _ref$version === void 0 ? "v11.0" : _ref$version;

  var E = function E() {
    y && console.log("[react-messenger-chat-plugin] expanding on init");

    try {
      var _performance, _performance$getEntri;

      var _e = JSON.parse(localStorage.getItem("__fb_chat_plugin")),
          _t = "navigate" !== ((_performance = performance) === null || _performance === void 0 ? void 0 : (_performance$getEntri = _performance.getEntriesByType("navigation")[0]) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri.type);

      _e && "hidden" === (_e === null || _e === void 0 ? void 0 : _e.visibility) && !_t && FB.CustomerChat.show();
    } catch (e) {
      throw console.warn("Probblem when autoexpanding messenger chatbox occured. Please file an issue on github."), new Error(e);
    }
  };

  return t(function () {
    try {
      s = y, function () {
        y && console.log("[react-messenger-chat-plugin] initializing messenger plugin");

        try {
          var _e2 = document.getElementById("fb-customer-chat");

          _e2.setAttribute("page_id", o), _e2.setAttribute("attribution", "biz_inbox"), g && _e2.setAttribute("theme_color", g), l && _e2.setAttribute("logged_in_greeting", l), u && _e2.setAttribute("logged_out_greeting", u), c ? (_e2.setAttribute("greeting_dialog_display", "show"), _e2.setAttribute("greeting_dialog_delay", 0)) : _e2.setAttribute("greeting_dialog_display", "hide"), h && _e2.setAttribute("ref", h), window.fbAsyncInit = function () {
            FB.init({
              xfbml: !0,
              version: C
            }), FB.Event.subscribe("customerchat.load", function () {
              m && m();
            }), FB.Event.subscribe("xfbml.render", function () {
              void 0 !== a && i(a), c && setTimeout(E, 3e3), d && d(), n = !0;
            }), FB.Event.subscribe("customerchat.show", function () {
              b && b();
            }), FB.Event.subscribe("customerchat.hide", function () {
              p && p();
            }), FB.Event.subscribe("customerchat.dialogShow", function () {
              w && w();
            }), FB.Event.subscribe("customerchat.dialogHide", function () {
              f && f();
            });
          }, function (e, t, o) {
            var n,
                s = e.getElementsByTagName(t)[0];
            e.getElementById(o) || (n = e.createElement(t), n.id = o, n.src = "https://connect.facebook.net/".concat(r, "/sdk/xfbml.customerchat.js"), s.parentNode.insertBefore(n, s));
          }(document, "script", "facebook-jssdk");
        } catch (e) {
          throw e;
        }
      }();
    } catch (e) {
      console.log(e);
    }
  }), e.createElement("div", null, e.createElement("div", {
    id: "fb-root"
  }), e.createElement("div", {
    id: "fb-customer-chat",
    className: "fb-customerchat"
  }));
},
    i = function i(e) {
  s && console.log("[react-messenger-chat-plugin] setting messenger height: ".concat(e));
  var t = document.querySelectorAll("[data-testid='bubble_iframe']");

  if (t && t.length > 0) {
    t[0].style.bottom = "".concat(e, "px");
  } else console.warn("Could not set height of messenger button.");

  var o = document.querySelectorAll("[data-testid='dialog_iframe']");

  if (t && o.length > 0) {
    o[0].style.bottom = "".concat(e + 56, "px");
  } else console.warn("Could not set height of messenger dialog container.");
},
    g = function g(e) {
  s && console.log("[react-messenger-chat-plugin] showing messenger with argument \"shouldShowDialog\": ".concat(e));

  try {
    var _FB;

    n && (_FB = FB) !== null && _FB !== void 0 && _FB.CustomerChat ? FB.CustomerChat.show(e) : n || console.warn("Messenger could not expand messenger due to the messenger chat not beeing mounted yet.");
  } catch (e) {
    throw new Error(e);
  }
},
    a = function a() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
  s && console.log("[react-messenger-chat-plugin] hiding messenger with argument");

  try {
    var _FB2;

    n && (_FB2 = FB) !== null && _FB2 !== void 0 && _FB2.CustomerChat ? FB.CustomerChat.hide() : n || console.warn("Messenger could not hide messenger due to the messenger chat not beeing mounted yet.");
  } catch (e) {
    throw new Error(e);
  }
},
    c = function c() {
  s && console.log("[react-messenger-chat-plugin] showing dialog");

  try {
    var _FB3;

    n && (_FB3 = FB) !== null && _FB3 !== void 0 && _FB3.CustomerChat ? FB.CustomerChat.showDialog() : n || console.warn("Messenger could not show dialog due to the messenger chat not beeing mounted yet.");
  } catch (e) {
    throw new Error(e);
  }
},
    l = function l() {
  s && console.log("[react-messenger-chat-plugin] hiding dialog");

  try {
    var _FB4;

    n && (_FB4 = FB) !== null && _FB4 !== void 0 && _FB4.CustomerChat ? FB.CustomerChat.hideDialog() : n || console.warn("Messenger could not hide dialog due to the messenger chat not beeing mounted yet.");
  } catch (e) {
    throw new Error(e);
  }
};

r.propTypes = {
  pageId: o.string.isRequired,
  language: o.string,
  themeColor: o.string,
  height: o.number,
  autoExpand: o.bool,
  loggedInGreeting: o.string,
  loggedOutGreeting: o.string,
  ref: o.string,
  onMessengerMounted: o.func,
  onMessengerLoad: o.func,
  onMessengerShow: o.func,
  onMessengerHide: o.func,
  onMessengerDialogShow: o.func,
  onMessengerDialogHide: o.func,
  debugMode: o.bool,
  version: o.string,
  custom: function custom(e) {
    e.debugMode && console.log(e);
    var t = e.themeColor;
    if (t && !/^#(?:[0-9a-fA-F]{3}){1,2}$/.test(t)) return new Error("Invalid hexcolor format on prop: themeColor");
  }
};
export { r as MessengerChat, l as hideDialog, a as hideMessenger, i as setMessengerHeight, c as showDialog, g as showMessenger };